import { getEnvVar } from "../config/gsb-config.js";
const logConsole = console;
class Logger {
    static instance;
    isDevelopment = getEnvVar("NODE_ENV", "production") === "development";
    isDetailedLogs = getEnvVar("NEXT_PUBLIC_DETAILED_LOGS", "false") === "true";
    constructor() { }
    static getInstance() {
        if (!Logger.instance) {
            Logger.instance = new Logger();
        }
        return Logger.instance;
    }
    log(level, ...args) {
        if (!this.isDevelopment && level === "debug")
            return;
        const timestamp = new Date().toISOString();
        const prefix = `[${timestamp}] [${level.toUpperCase()}]`;
        if (level === "error") {
            logConsole.error(prefix, ...args);
        }
        else if (level === "warn") {
            logConsole.warn(prefix, ...args);
        }
        else if (this.isDevelopment) {
            if (level === "debug" && this.isDetailedLogs) {
                logConsole.debug(prefix, ...args);
            }
            else if (level === "info") {
                logConsole.info(prefix, ...args);
            }
        }
    }
    debug(...args) {
        this.log("debug", ...args);
    }
    info(...args) {
        this.log("info", ...args);
    }
    warn(...args) {
        this.log("warn", ...args);
    }
    error(...args) {
        this.log("error", ...args);
    }
}
export const logger = Logger.getInstance();
//# sourceMappingURL=logger.js.map